export class Countdown {
  constructor(difference) {
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.widthType = "自动"
    this.heightType = "自动"
    this.width = 312
    this.height = 32
    this.top = 0
    this.left = 0
    this.innerElement = "cxCountdown"
    this.content = "倒计时"
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.mainConfig = {}
    this.numberConfig = {}
    this.unitConfig = {}
    this.endTime = ""
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
